<template>
    <main class="login-form">
        <h1>Εκτύπωση Βεβαίωσης</h1>
        <div>
        <button class="btn btn-success" v-on:click="generate">Εκτύπωση Βεβαίωσης Εγγραφής</button>
        </div>
        <br>
        <div style="width: 50%; margin: auto;">
        <Message  v-if="msgVisible" v-bind:msgClass="msgClass"
                  v-bind:message="message"></Message>
        </div>
    </main>
</template>

<script>
    import {HTTP} from "../main.js";
    import {Structs} from "../structs.js"
    import Message from "@/components/Message.vue";
    require("pdfmake/build/pdfmake.js");
    require("pdfmake/build/vfs_fonts.js");
    var pdfMake = require('pdfmake/build/pdfmake.js');
    var pdfFonts = require('pdfmake/build/vfs_fonts.js');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    export default {
        components: {Message},
        data: function() {
            return {
                simpleUser: Structs.SimpleUser(),
                status: '',
                message: '',
                msgVisible: false,
                msgClass: ''
            };
        },

        mounted() {
            var efsa = this.$store.getters.efsa;

            let url = "/users/" + efsa;

            this.$store.dispatch('loading');

            HTTP.get(url).then(response => {
                this.simpleUser = response.data;
            }).catch((error) => {
                console.error(error);
                this.$store.dispatch('stop_loading');
            }).finally(() => {
                this.$store.dispatch('stop_loading');
            });
        },

        methods: {
            getBase64ImageFromURL(url) {
                return new Promise((resolve, reject) => {
                    var img = new Image();
                    img.setAttribute("crossOrigin", "anonymous");
                    img.onload = () => {
                        var canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        var dataURL = canvas.toDataURL("image/png");
                        resolve(dataURL);
                    };
                    img.onerror = error => {
                        reject(error);
                    };
                    img.src = url;
                });
            },

            async generate() {
                HTTP.get("/users/validation").then( async response => {
                    var today = new Date();
                    var currentDate = today.getDate() + "/" + (today.getMonth()+1) + "/" + today.getFullYear();

                    var mainText = "Ο κάτωθι υπογεγραμμένος " + this.simpleUser.efedros.efEpwnymo + " " + this.simpleUser.efedros.efOnoma + " με ΑΣΜ " + this.simpleUser.efedros.efSa +  " δηλώνω υπεύθυνα ότι ολοκλήρωσα την εγγραφή μου στην Ηλεκτρονική Εφαρμογή Αποστολής Ειδοποίησης Εφέδρου.\n\n\n";
                    var signature = currentDate + "\n" + "-Ο-" + "Δηλών";
                    var docDefinition = {

                        pageSize: 'A4',
                        pageMargins: [80, 100],
                        background: [{
                            image: await this.getBase64ImageFromURL("/files/HellenicArmySeal.png"),
                            opacity: 0.3,
                            width: 400,
                            absolutePosition: {x: 100, y: 200}
                        }],

                        header: {
                            margin: 40,
                            alignment: 'center',
                            text: 'ΥΠΕΥΘΥΝΗ ΔΗΛΩΣΗ',
                            bold: true,
                            decoration: 'underline',
                            fontSize: 22
                        },

                        content: [
                            {text: mainText, style: 'mainText'},
                            {text: signature, style: 'signature'}
                        ],

                        styles: {
                            mainText: {
                                alignment: 'justify',
                                pageBreak: 'before'
                            },
                            signature: {
                                alignment: 'right',
                                italics: true
                            }
                        },
                    }

                    pdfMake.createPdf(docDefinition).download("vevaiwsiEggrafis.pdf");

                }).catch((e) => {
                    var resp = e.response;
                    this.message = (resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText;
                    if (this.message === "") {
                        this.message = "Υπήρξε κάποιο πρόβλημα με την αίτηση σας!"
                    }
                    this.msgClass = 'danger';
                    this.msgVisible = true;});
            }
        },
    };
</script>
               